export const types = {
  MontosNotasVentaLoaded: "[Dashboard] MontoTotal notas venta Loaded",
  MontosComprobantesLoaded: "[Dashboard] MontoTotal comprobantes Loaded",
  dashboardLogout: "[Dashboard] Dashboard Logout",
};
